// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__93B9K","errorLogs":"EditorFooter_errorLogs__BnG4q"};